<template>
  <section :class="computedBackground">
    <ContentContainer>
      <template v-if="variation === 'default'">
        <MBZStatisticsDefault :statistics="props.statisticsStatsBlockCon">
          <template v-slot:header>
            <slot name="statisticsHeader" />
          </template>
        </MBZStatisticsDefault>
      </template>
      <template v-else>
        <MBZStatisticsHorizontal :statistics="props.statisticsStatsBlockCon" />
      </template>
    </ContentContainer>
  </section>
</template>

<script setup lang="ts">
import type { StatisticsStatsBlockCon } from '~/types';

import MBZStatisticsDefault from '@/components/global/MBZ/Statistics/Default.vue';
import MBZStatisticsHorizontal from '@/components/global/MBZ/Statistics/Horizontal.vue';

defineSlots<{
  statisticsHeader(): any;
}>();

const props = defineProps<{
  statisticsStatsBlockCon: StatisticsStatsBlockCon[];
  variation: 'horizontal' | 'default';
  backgroundColour?: 'blue' | 'white' | 'sand';
}>();

const computedBackground = computed(() => {
  switch (props.backgroundColour) {
    case 'blue':
      return 'background-pattern-navy-500';

    case 'sand':
      return 'background-pattern-sand-100';

    case 'white':
      return 'background-pattern-white';

    default:
      return 'background-pattern-white';
  }
});
</script>
